/* HV-CUSTOM: recent-searches.js komplett auf Live-Stand (Security-Haertung: URL-Validierung,
   sichere DOM-Erzeugung/Query-Sanitizing statt Base-innerHTML). Funktionsumfang
   identisch zur 18.2.2-Base. Siehe docs/development/CUSTOMIZATIONS.md (HV-JS-SEC) */
/*! Copyright (c) Safe As Milk. All rights reserved. */
class RecentSearches extends HTMLElement {
    constructor() {
        super();
        this.update();
    }
    
    /**
     * Validates if a URL is safe (same-origin only)
     * @param {string} url - URL to validate
     * @returns {boolean} - True if URL is safe
     */
    isValidUrl(url) {
        try {
            const parsed = new URL(url, window.location.origin);
            // Only allow same-origin URLs
            return parsed.origin === window.location.origin;
        } catch {
            return false;
        }
    }
    
    /**
     * Escapes HTML special characters
     * @param {string} text - Text to escape
     * @returns {string} - Escaped text
     */
    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
    
    update() {
        const recentSearchesStoredString = localStorage.getItem("recentSearches");
        if (!recentSearchesStoredString) return;
        
        const ul = this.querySelector("ul");
        if (!ul) return;
        
        let recentSearchesStored;
        try {
            recentSearchesStored = JSON.parse(recentSearchesStoredString);
            // Validate data structure
            if (!Array.isArray(recentSearchesStored)) {
                throw new Error("Invalid data structure");
            }
        } catch (error) {
            // If parsing fails or data is invalid, clear localStorage
            console.error("Error parsing recent searches:", error);
            localStorage.removeItem("recentSearches");
            return;
        }
        
        if (recentSearchesStored.length > 0) {
            // Filter and validate items
            const validSearches = recentSearchesStored
                .filter(item => {
                    // Validate item structure
                    if (!item || typeof item !== 'object') return false;
                    if (!item.query || typeof item.query !== 'string') return false;
                    if (!item.uri || typeof item.uri !== 'string') return false;
                    // Validate URL is safe
                    return this.isValidUrl(item.uri);
                })
                .slice(0, 5); // Limit to 5 items
            
            if (validSearches.length > 0) {
                this.parentElement.classList.add("has-recent-searches");
                
                // Use textContent and create elements safely instead of innerHTML
                ul.textContent = ''; // Clear existing content
                validSearches.reverse().forEach(item => {
                    const li = document.createElement('li');
                    li.className = 'search__nav-item';
                    
                    const a = document.createElement('a');
                    a.href = item.uri; // URL is already validated
                    a.className = 'search__nav-link';
                    a.textContent = item.query; // Use textContent instead of innerHTML
                    
                    li.appendChild(a);
                    ul.appendChild(li);
                });
                
                this.removeAttribute("hidden");
            } else {
                // No valid searches, clear localStorage
                localStorage.removeItem("recentSearches");
            }
        }
    }
}

customElements.define("recent-searches", RecentSearches);
//# sourceMappingURL=recent-searches.js.map
